import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type SigninView = 'sso' | 'password';

export type SigninFormState = {
  view: SigninView;
  submitInProgress: boolean;
  lastErrorKey: string | null;
};

const initialState: SigninFormState = {
  view: 'sso',
  submitInProgress: false,
  lastErrorKey: null,
};

export const signinFormSlice = createSlice({
  name: 'signinForm',
  initialState,
  reducers: {
    setView(state, action: PayloadAction<SigninView>) {
      state.view = action.payload;
    },
    setSubmitInProgress(state, action: PayloadAction<boolean>) {
      state.submitInProgress = action.payload;
    },
    setLastErrorKey(state, action: PayloadAction<string | null>) {
      state.lastErrorKey = action.payload;
    },
    clearForm() {
      return initialState;
    },
  },
});

export const { setView, setSubmitInProgress, setLastErrorKey, clearForm } =
  signinFormSlice.actions;

export const selectSigninForm = (state: { signinForm: SigninFormState }) =>
  state.signinForm;
